(function ( $ ) {

    //------------------------------------   OSP  ----------------------------------------------------------------------

    $.isNumber = function ( n ) {
        n = n.replace( ',', '' );
        return !isNaN( parseFloat( n ) ) && isFinite( n );
    };

    var getDialogLevelType = function ( level ) {
        var type = "";

        if ( level === null ) {
            type = "info"
        }
        else if ( level === 1 ) {
            type = "success"
        }
        else if ( level === 2 ) {
            type = "warning"
        }
        else if ( level === 3 ) {
            type = "error"
        }

        return type;
    };

    $.confirmDialog = function ( text, title, level, okFunction ) {
        swal( {
            title: title || $( '#page-title' ).val(),
            text: text,
            type: getDialogLevelType( level ),
            showCancelButton: true,
            confirmButtonColor: "#4cae4c",
            confirmButtonText: "Ok",
            closeOnConfirm: true
        }, function () {
            if ( typeof okFunction == 'function' ) {
                okFunction();
            }
        } );
    };

    $.okDialog = function ( text, okFunction, title, level ) {
        swal( {
            title: title || $( '#page-title' ).val(),
            text: text,
            type: getDialogLevelType( level ),
            showCancelButton: false,
            confirmButtonColor: "#4cae4c",
            confirmButtonText: "Ok",
            closeOnConfirm: true
        }, function () {
            if (typeof okFunction === "function") {
                okFunction();
            }
            else if (okFunction) {
                $.okDialogFunction();
            }
        } );
    };

    $.okcancelDialog = function ( text, param, cancelFunction, title ) {

        swal( {
            title: title || $( '#page-title' ).val(),
            text: text,
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#4cae4c",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: true
        }, function ( isConfirm ) {
            if ( isConfirm ) {
                $.okDialogFunction( param );
            }
            else {
                if ( cancelFunction ) {
                    $.cancelDialogFunction( param );
                }
            }
        } );
    };

    $.okAjaxDialog = function ( text, title, level ) {
        swal( {
            title: title || $( '#page-title' ).val(),
            text: text,
            type: getDialogLevelType( level ),
            confirmButtonColor: "#4cae4c",
            showCancelButton: true,
            closeOnConfirm: false,
            showLoaderOnConfirm: true,
            html: true
        }, function () {
            $.okDialogFunction();
        } );
    };

    $.parseStringToDate = function ( value ) {
        if ( value == "" )
            return "";
        var dateresult = value.split( '/' );
        return new Date( dateresult[ 2 ], dateresult[ 1 ] - 1, dateresult[ 0 ] );
    };

    $.isDateInRange = function ( aData, daterangeinput ) {
        var iColumn = 1;
        var iMin    = (daterangeinput != "") ? daterangeinput.split( ' - ' )[ 0 ] : "";
        var iMax    = (daterangeinput != "") ? daterangeinput.split( ' - ' )[ 1 ] : "";
        var iDate   = aData[ iColumn ];

        iMin  = $.parseStringToDate( iMin );
        iMax  = $.parseStringToDate( iMax );
        iDate = $.parseStringToDate( iDate );

        if ( iMin == "" && iMax == "" ) {
            return true;
        }
        else if ( iMin == "" && iDate <= iMax ) {
            return true;
        }
        else if ( iMin <= iDate && "" == iMax ) {
            return true;
        }
        else if ( iMin <= iDate && iDate <= iMax ) {
            return true;
        }
        return false;
    }

    $.getRow = function ( tableName, currElement ) {
        var target_row = $( currElement ).closest( "tr" )[ 0 ];
        var aPos       = $( tableName ).dataTable().fnGetPosition( target_row );
        var aData      = $( tableName ).dataTable().fnGetData( aPos );
        return aData;
    };


    $.validatePhoneNumber = function (parentID) {
        var valid = true;
        var regex = /^[0-9\+]{1,}[0-9\ ]{3,15}$/;
        $('#' + parentID + ' *[phone]').each(function () {
            var trimValue = $(this).val().trim();
            if (trimValue !== "")
                if (!regex.test(trimValue)) {
                    valid = false;
                    $(this).addClass('error');
                }
        });
        return valid;
    };

    $.validateEmail = function (parentID) {
        var valid = true;
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        $('#' + parentID + ' *[email]').each(function () {
            var trimValue = $(this).val().trim();
            if (trimValue !== "")
                if (!regex.test(trimValue)) {
                    valid = false;
                    $(this).addClass('error');
                }
        });
        return valid;
    };

    $.validateRequired = function ( parentID ) {
        var valid = true;
        $('#' + parentID + ' *[required]').each(function () {
            var value = $(this).val();

            if (value == null) {
                valid = false;
                $(this).addClass('error');
                return;
            }

            if (typeof value === "object") {
                value = value.join();
            }

            if (value === null || value.trim() === "") {
                valid = false;
                $( this ).addClass( 'error' );
            }
        });

        return valid;
    };

    $.validatePositiveNumber = function ( parentID ) {
        var valid = true;
        $( '#' + parentID + ' input[data-positive-number]' ).each( function () {
            if ( $( this ).val() !== "" && (!$.isNumber( $( this ).val() ) || Number( $( this ).val() ) <= 0) )
                valid = false;
        } );
        $( '#' + parentID + ' input[data-positiveorzero-number]' ).each( function () {
            if ( $( this ).val() !== "" && (!$.isNumber( $( this ).val() ) || Number( $( this ).val() ) < 0) )
                valid = false;
        } );
        return valid;
    };

    $.cleanDGs = function () {
        $( '#unCode, #dgInputForm input' ).val( '' );
        $( '#unit' ).val( 'Kg' );
        $( '#packGroup' ).val( 'I' );
        $( '#panelDGs' ).addClass( 'hidden' );
        $( '#isDGs' ).prop( 'checked', false );
    };

    $(document).on('click', '#collapseExpandAll', function ( e ) {
        if ( $( '#collapseExpandAll' ).find( "i" ).hasClass( "fa-minus-square-o" ) ) {
            $( '#collapseExpandAll' ).find( "i" ).removeClass( "fa-minus-square-o" ).addClass( "fa-plus-square-o" );
            $( '.dataTable' ).dataTable().find( '.expanded-group' ).trigger( 'click' );
        }
        else {
            $( '#collapseExpandAll' ).find( "i" ).removeClass( "fa-plus-square-o" ).addClass( "fa-minus-square-o" );
            $( '.dataTable' ).dataTable().find( '.collapsed-group' ).trigger( 'click' );
        }
    } );

    $(document).on('click', '.collapsed-group', function ( e ) {
        if ( $( '.dataTable' ).dataTable().find( '.expanded-group' ).length === 0 )
            $( '#collapseExpandAll' ).find( "i" ).removeClass( "fa fa-minus-square-o" ).addClass( "fa fa-plus-square-o" );
        $( this ).find( "i" ).removeClass( "fa fa-minus-square-o" ).addClass( "fa fa-plus-square-o" );
    } );

    $(document).on('click', '.expanded-group', function ( e ) {
        $( '#collapseExpandAll' ).find( "i" ).removeClass( "fa fa-plus-square-o" ).addClass( "fa fa-minus-square-o" );
        $( this ).find( "i" ).removeClass( "fa fa-plus-square-o" ).addClass( "fa fa-minus-square-o" );
    } );

    $.refreshReportGridView = function ( reportUrl ) {
        var startDate = $( '#dateRangePicker' ).val().split( " - " )[ 0 ];
        var endDate   = $( '#dateRangePicker' ).val().split( " - " )[ 1 ];
        if ( moment( startDate, 'DD/MM/YYYY' ).add( 'months', 1 ) >= moment( endDate, 'DD/MM/YYYY' ) ) {
            $.ajax( {
                type: 'POST',
                url: rootUrl + reportUrl,
                timeout: conf.ajaxTimeout,
                data: {
                    fromDate: startDate,
                    toDate: endDate
                },
                success: function ( data ) {
                    $( '.table-responsive' ).replaceWith( "<div class='table-responsive' >" + data + "</div>" );
                    oTable = $.buildDataTable();
                },
                error: function ( request, status, error ) {
                    if (status == "timeout"){
                        $.okDialog("There is too much data to generate this report, please contact your Account Manager", false, "Timeout", 2);
                    }else {
                        $.okDialog(error);
                    }
                }
            } );
        }
        else {
            $.okDialog( 'Date range must not be more than one month.' );
        }
    };

    $(document).on('focus', 'input,textarea', function ( e ) {
        $( this ).removeClass( "error" );
    } );

    $(document).on('change', 'input,textarea', function ( e ) {
        $( this ).removeClass( "error" );
    } );

})( jQuery );